<template lang="pug">
select(v-model='model')
  option
  option(:value='smallMode ? "cc" : "Corrente"') Conta corrente
  option(:value='smallMode ? "cp" : "Poupança"') Conta poupança
</template>

<script>
export default {
  props: {
    value: { type: String },
    smallMode: { type: Boolean, default: false },
  },
  computed: {
    model: {
      set(v) {
        this.$emit('input', v)
      },
      get() {
        return this.value
      },
    },
  },
}
</script>
